import { Injectable } from '@angular/core';
import { BaseCrudService } from '../../common/services/base-crud.service';
import { environment } from '../../../environments/environment';
import {
  NotificationItemType,
  NotificationUnreadCountType,
} from './models/notification.model';
import { ApiItemResponse } from '../../common/models/api';
import { Observable } from 'rxjs';

@Injectable()
export class SystemNotificationsService extends BaseCrudService<NotificationItemType> {
  protected resource: string = 'notifications/system';
  protected apiRoot: string = environment.baseUrl;
  baseUrl: string = `${this.apiRoot}`;

  unreadCount(): Observable<ApiItemResponse<NotificationUnreadCountType>> {
    return this.http.get<ApiItemResponse<NotificationUnreadCountType>>(
      `${this.apiRoot}/${this.resource}/unread`
    );
  }
}
